import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import de from 'vuetify/es5/locale/de';
import iconQuerschnitt from '../components/customIcons/iconQuerschnitt';
import iconNewAuflager from '../components/customIcons/iconNewAuflager';
import iconNewKnoten from '../components/customIcons/iconNewKnoten';
import iconNewGelenk from '../components/customIcons/iconNewGelenk';

Vue.use(Vuetify);

export default new Vuetify({
    lang: {
      locales: { de },
      current: 'de',
    },
  icons: {
    iconfont: 'md',
    values: {
        iconQuerschnitt: { component: iconQuerschnitt},
        iconNewAuflager: { component: iconNewAuflager},
        iconNewKnoten: { component: iconNewKnoten},
        iconNewGelenk: { component: iconNewGelenk}
      },
  },
});
